function Sheets({ className = 'h-6 w-6' }) {
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.26767 0C2.66517 0 2.17676 0.488417 2.17676 1.09091V14.9091C2.17676 15.5116 2.66517 16 3.26767 16H12.7222C13.3247 16 13.8131 15.5116 13.8131 14.9091V4.36364L9.44949 0H3.26767Z'
        fill='#34A953'
      />
      <path
        d='M9.44824 0L13.8119 4.36364H9.44827C9.44827 4.40359 9.44827 4.40359 9.44827 4.36364L9.44824 0Z'
        fill='#188138'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.8131 7.45459V12.9091H4.17676V7.45459H7.51767H11.8131ZM7.51767 8.6107H5.1313V9.87495H7.51767V8.6107ZM8.47221 9.87495V8.6107H10.8586V9.87495H8.47221ZM7.51767 10.6335H5.1313V11.8977H7.51767V10.6335ZM8.47221 11.8977V10.6335H10.8586V11.8977H8.47221Z'
        fill='white'
      />
    </svg>
  )
}
export default Sheets
